import { createFileRoute } from '@tanstack/react-router';

import BuslineGeneral from '@/modules/buslines/pages/BuslineGeneral';

import { Route as BuslinePageRoute } from './route';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/buslines/$buslineId/',
)({
  head: () => ({
    meta: [{ title: 'Detalhes da Rota' }],
  }),
  component: function BuslineGeneralRoute() {
    const busline = BuslinePageRoute.useLoaderData();

    return <BuslineGeneral busline={busline} />;
  },
});
